import PubSub from "underpub-js";

var FormWithContactInfo = function(options) {

	this.options = {
		$el: false,
		baseClass: 'comp-FormWithContactInfo',
	};

	$.extend(true, this.options, options);

};

FormWithContactInfo.prototype.init = function() {

	var self = this;

	var $form = this.options.$el.find("form");

	// Submit tracking events when the form is submitted.
	$form.on('onAfterFormieSubmit', function(e) {

		// only fire these if the relevant tracking scripts have been set up in SEOmatic
		if(typeof gtag !== "undefined"){
			gtag('event', 'generate_lead', {
                'event_category' : 'engagement'
            });
		}

		if(typeof fbq !== "undefined"){
			fbq('track', 'Lead');
		}

	});

};

export default FormWithContactInfo;
